import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import Skeleton from "@material-ui/lab/Skeleton";
import { Typography } from "@material-ui/core";



// All the incoming values
interface IProps {
    label: string;
}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch;
export const Loading = (props: AllProps) => {
    const classes = useStyles(useTheme());
    return (<><Typography variant="caption" color="textSecondary">{props.label}</Typography>
        <Skeleton className={classes.skeleton} /></>
    )
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({
    skeleton: {
        width: '100%',
        height: '56px', // Default height for Material-UI TextField
        borderRadius: theme.shape.borderRadius,
    },
 }));